<template>
  <a href="/">
    <img src="../../img/logo.svg" class="w-24" alt="" />
  </a>
</template>
